import React from 'react';
import cx from 'classnames';

import style from './HomeInvoiceSection.module.scss';

export default function HomeInvoiceSection() {
  return (
    <div className={style.section}>
      <div className="container">
        <div className="lending-title">
          <div className="icon-wrapper">
            <span className="icon icon-shield" />
          </div>

          <div>
            <div className="text">Turnkey EOR</div>
            <div className="hint">
              The infrastructure you need to make more placements.
            </div>
          </div>

          <div className={cx('hint right-box', style.rightBox)}>
            Employer of Record that meets the urgency of your day-to-day
            operations.
          </div>
        </div>

        <div className={style.itemHolder}>
          <div className={style.item}>
            <div className={style.itemFront}>
              <div className={style.itemIconWrapper}>
                <span className="icon icon-professional" />
              </div>
              <div className={style.itemText}>Employment Liability</div>
            </div>
            <div className={style.itemBack}>
              <div className={style.itemText}>
                Employment Liability: IRS, EEOC, DOL
              </div>
            </div>
          </div>

          <div className={style.item}>
            <div className={style.itemFront}>
              <div className={style.itemIconWrapper}>
                <span className="icon icon-statistics" />
              </div>
              <div className={style.itemText}>Tax Reporting</div>
            </div>
            <div className={style.itemBack}>
              <div className={style.itemText}>
                Tax Reporting: “Local, state and federal taxes”
              </div>
            </div>
          </div>

          <div className={style.item}>
            <div className={style.itemFront}>
              <div className={style.itemIconWrapper}>
                <span className="icon icon-call" />
              </div>
              <div className={style.itemText}>Claim Management</div>
            </div>
            <div className={style.itemBack}>
              <div className={style.itemText}>
                Claim Management: “Workman's Comp & Unemployment”
              </div>
            </div>
          </div>

          <div className={style.item}>
            <div className={style.itemFront}>
              <div className={style.itemIconWrapper}>
                <span className="icon icon-planning" />
              </div>
              <div className={style.itemText}>Benefits Administration</div>
            </div>
            <div className={style.itemBack}>
              <div className={style.itemText}>
                Benefits Administration: “Major Medical, ACA & Cobra”.
              </div>
            </div>
          </div>

          <div className={style.item}>
            <div className={style.itemFront}>
              <div className={style.itemIconWrapper}>
                <span className="icon icon-insurance" />
              </div>
              <div className={style.itemText}>Business Insurance Policies</div>
            </div>
            <div className={style.itemBack}>
              <div className={style.itemText}>
                Business Insurance Policies: “Certificate of Insurances”
              </div>
            </div>
          </div>

          <div className={style.item}>
            <div className={style.itemFront}>
              <div className={style.itemIconWrapper}>
                <span className="icon icon-personal-data" />
              </div>
              <div className={style.itemText}>Customized Infrastructure</div>
            </div>
            <div className={style.itemBack}>
              <div className={style.itemText}>
                Customized Infrastructure: “Platform Technology Experience”
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
